interface Props {
  message?: string;
}

export function EmptyState({ message = 'Нет данных за выбранный период' }: Props) {
  return (
    <div className='flex items-center justify-center py-20 text-muted-foreground text-sm'>
      {message}
    </div>
  );
}
